// removed by extract-text-webpack-plugin
module.exports = {"sea-buckthron":"#faa634","header":"header_header_2tLSG","logo":"header_logo_3gf_E","navItem":"header_navItem_4UwDr","navItemHome":"header_navItemHome_3fhRk","close":"header_close_3RkdG","getInTouchContainer":"header_getInTouchContainer_VOGdv","getInTouch":"header_getInTouch_Ys2Ha","icon":"header_icon_TpE_z","modalContainer":"header_modalContainer_3Ce7_"};


//////////////////
// WEBPACK FOOTER
// ./src/component/header/header.css
// module id = 365
// module chunks = 4